<div class="block--content block" id="main-content">
    <ridango-page-content-wrapper>
        <rwidget-alert></rwidget-alert>

        <div class="ticket">
            <div class="card-detail-view-area">
                <ridango-ui-back-button (onBack)="back()"
                    >{{ 'RELATED_CARD_DETAIL_BACK_LINK' | translate }}
                </ridango-ui-back-button>

                <rwidget-related-card-detail
                    (onActionSelected)="actionSelected($event)"
                    (navigateToCardList)="navigateToCardList()"
                    (onAddMoneyRequest)="navigate([translate.currentLang, 'purchase', 'wallet'])">
                </rwidget-related-card-detail>
            </div>
            <rwidget-account-related-card-tickets
                *ngIf="environment.THEME_NAME !== themeFeature.TARTU && !(selectedRelatedCard$ | async)?.blocked"
                (onNavigateRequest)="
                    environment.ENABLE_PURCHASE_V2
                        ? navigate([translate.currentLang, 'purchase-v2'])
                        : navigate([translate.currentLang, 'purchase', 'ticket'])
                ">
            </rwidget-account-related-card-tickets>
        </div>
    </ridango-page-content-wrapper>
</div>
